module.exports = __webpack_public_path__ + "media/packs/images/flags/AR-ac8609ba47e9165c6524d0295ee354f9.svg";